import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`

    .swal2-container, .toastComponent{
      z-index: 99999999999999999999999999999;
    }

    .swal2-confirm {
      background-color: ${(props) => props?.theme?.COLOR_PRIMARY};
      text-transform: uppercase;
      letter-spacing: 0.5px;
      font-weight: 700;
      font-size: 15px;
      font-family: 'Open Sans', sans-serif;
    }

    .tool-tip {
      color: ${(props) => props?.theme?.COLOR_PRIMARY};
      background: #F1F2F4;
    }

    .swal2-popup, .swal2-modal, .swal2-show {
      width: 100%;
      max-width: 605px;
    }

    .swal2-actions {
      width: 100%;
      background-color: #F5F7FA;
      padding: 14px  24px;
      height: 79px;
      flex-direction: row-reverse;
      align-items: center;
      justify-content: flex-start;
    }

    .swal2-close{
      color: ${(props) => props?.theme?.COLOR_TEXT};
    }

    .swal2-styled.swal2-cancel {
      background-color: #F5F7FA;
      color: ${(props) => props?.theme?.COLOR_BLACK};
      font-weight: 700;
      font-size: 14px;
      line-height: 19px;
      text-align: center;


      @media (hover: hover) {
        &:hover {
          background-color: #F5F7FA;
        }
      }
    }

    .swal2-confirm {
      background-color: ${(props) => props?.theme?.COLOR_PRIMARY || 'none'} !important;
      outline: none;
      border: none;
      color: ${(props) => props?.theme?.COLOR_WHITE};
    }

    .swal2-cancel {
      background-color: ${(props) => props.theme.COLOR_WHITE};
      :hover {
        background-color: none;
      }
    }

    .swal2-title {
      text-align: left;
      font-weight: 700;
      font-family: 'inter';
      font-size: 28px;
      line-height: 34px;
      letter-spacing: 0.541667px;
      color: black !important;
      margin: 0 18px;
    }

    .mixin-title {
      font-weight: 600;
      font-size: 14px;
      line-height: 24px;
      padding: 0;
      margin: 0 !important;
    }

    .swal2-html-container {
      text-align: left !important;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color:${(props) => props?.theme?.COLOR_TEXT};
      padding: 0 4px;
      margin-top: 24px !important;
      margin-bottom: 32px !important;
      margin-left: 32px !important;
      margin-right: 32px !important;
    }

    .swal2-container.swal2-center>.swal2-popup {
      padding: 0;
      display: flex;
    }

    button.swal2-cancel.swal2-styled.swal2-default-outline {
      border: 1px solid black;
      color: black;
      margin-right: 19px;
    }
    button.swal2-confirm.swal2-styled.swal2-default-outline{
      background-color: ${(props) => props?.theme?.buttonPrimaryColor} !important;
    }

    .swal2-select {
      height: 40px;
      padding: 10px;
      color: #63636d;
      font-size: 14px;
      border-radius: 4px;
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      background: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23090031' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'><path d='M6 9l6 6 6-6'/></svg>")
        no-repeat;
      background-size: 18px;
      background-position: 100% 50%;
      background-repeat: no-repeat;
      outline: none;
    
      :hover {
        background: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23B6B7B5' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'><path d='M6 9l6 6 6-6'/></svg>")
          no-repeat;
        background-size: 18px;
        background-position: 100% 50%;
      }
    
      ::placeholder {
        font-weight: 400;
      }
    
      :disabled {
        background: #eeeff0;
        outline: none;
      }
    }
    .swal2-toast .swal2-icon {
      border: none !important;
  }

    .red {
      color: ${(props) => props.theme.COLOR_PRIMARY};
    }
    .blue {
      color: ${(props) => props.theme.COLOR_BLUE}
    }
    .orange {
      color: ${({ theme }) => theme.COLOR_ORANGE} 
    }
    .green {
      color: ${(props) => props.theme.COLOR_STATUS_GREEN}
    }
`;

export default {
  GlobalStyles,
};
